/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostAnomalyImpactByBillingWidgetConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("CostAnomalyImpactByBillingWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return CostAnomalyImpactByBillingWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<CostAnomalyImpactByBillingWidgetConfiguration>): CostAnomalyImpactByBillingWidgetConfiguration {
        let obj = Object.assign(new CostAnomalyImpactByBillingWidgetConfiguration(), model);
        CostAnomalyImpactByBillingWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostAnomalyImpactByBillingWidgetConfiguration>): CostAnomalyImpactByBillingWidgetConfiguration {
        if (!model) return null;
        return CostAnomalyImpactByBillingWidgetConfiguration.newInstance(<CostAnomalyImpactByBillingWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostAnomalyImpactByBillingWidgetConfiguration) {
        if (!obj) return;

        models.CostAnomalyImpactByBillingWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostAnomalyImpactByBillingWidgetConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CostAnomalyImpactByBillingWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Type of Category
     */
    categoryType: models.CategoryType;

}
